/**
 * Categorías curadas de cursos. Deben mantenerse en sync con los slugs de
 * `programs` en platforms/academy/apps/academy-frontend/src/config/schools.ts —
 * ese es el catálogo público que filtra cursos por `category` (match exacto),
 * así que usar estos mismos valores es lo que hace que un curso sea
 * encontrable por su tag ahí.
 */
export const COURSE_CATEGORIES = [
  { value: "modelismo-coheteria", label: "Modelismo Espacial" },
  { value: "aeromodelismo", label: "Aeromodelismo" },
  { value: "aviacion-aeronautica", label: "Aviación Y Aeronáutica" },
  { value: "exploracion-espacial", label: "Exploración Espacial" },
  { value: "seminare", label: "Programa Seminare" },
  { value: "satelites", label: "Satélites" },
  { value: "aves", label: "Programa Aves" },
]
